      if ($('.collection_slider-new').length) { 
$('.collection_slider-new').not('.slick-initialized').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59_1.svg?v=1709796392'></button>",
                nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59.svg?v=1709796153'></button>",
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
      }
      if ($('.collection_slider').length) {
 $('.collection_slider').not('.slick-initialized').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59_1.svg?v=1709796392'></button>",
                nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59.svg?v=1709796153'></button>",
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
      }
document.addEventListener("DOMContentLoaded", (event) => {
const cartDrawer = document.querySelector('cart-drawer');

const observer = new MutationObserver((mutationsList, observer) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList' || mutation.type === 'attributes') {
      if ($('.collection_slider-new').length) { 
        $('.collection_slider-new').not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
           prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59_1.svg?v=1709796392'></button>",
          nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59.svg?v=1709796153'></button>",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
      if ($('.collection_slider').length) {
        $('.collection_slider').not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
           prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59_1.svg?v=1709796392'></button>",
          nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0863/3329/2835/files/Vector_59.svg?v=1709796153'></button>",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  });
});

const config = {
  childList: true,
  attributes: true,
  subtree: true
};

observer.observe(cartDrawer, config);
});